<template> 
  <v-container>
    <v-layout row wrap class="flex_box">
      <v-flex xs12 sm6 md6 class="flex_item">
        <v-card flat>
          <v-img :src="this.product.image" aspect-ratio="1" height="400" width="400" contain class="mx-auto"></v-img>
             <h4  class="blue my-5 white--text text-xs-center">On Stock</h4>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 md6 class="flex_item">
        <v-card outlined  class="products_detail mx-auto mb-auto ">
          <v-card-text >
            <h2 class=" black--text text--darken-3">{{this.product.name}}</h2>            
            <!-- <h2 class="black--text text--darken-4 my-3">Paketin Määrä: {{this.product.packageamount}}</h2> -->
            <h2 class="blue--text text--darken-4 my-3">{{this.product.code}}</h2>
         <v-card class="pa-1 ">
            <h2 class=" gray--text text-xs-start text--darken-4 ">Kol ({{product.packageamount}} x ST)</h2> 
         </v-card>
            <h2 class="gray--text text--darken-4 my-3">Alv: % {{this.product.vatpercent}}</h2>
            <h2 class="gray--text text--darken-4 my-3">Koko: {{this.product.size}} {{this.product.measureunit}}</h2>
            <h2 class="gray--text text--darken-4 my-3">Price:</h2>
            
            <h2 class="red--text text--darken-2 my-3">{{currency}}{{this.product.price}} / {{currency}}{{this.product.package_price}} (paketti)</h2>
            <!-- <v-card-title  style="background:#efeded;">
                <p class="headline grey--text text--darken-3 px-3 ">{{this.product.category_name}}</p>
            </v-card-title> -->
            <!-- <p class="grey--text text--darken-2 my-3 pa-3" v-if="this.product.code" v-html="this.product.code" style="background:rgb(239, 237, 237);">
            </p> -->
          </v-card-text>
          <div class="d-flex">
            <v-btn large class="green white--text" @click="addToCart(product)">LISÄÄ OSTOSKORIIN</v-btn>
          </div> 
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>      
</template>

<script>
  import firebase from "firebase";
  import moment from 'moment'
    import axios from "axios";
  export default {
      data(){
        return{
          currency:null,      
          product:[],
          cart:this.$store.getters.cart 
        }
      },
      methods: {
        productInCart(product) {
          const cartItems = this.cart
          for (let i = 0; i < cartItems.length; i++) {
            if (cartItems[i].product.id === product.id) {
              return i       
            }
          }
          return null
        },      
        addToCart(product, quantity){
          const index = this.productInCart(product)
  //         console.log("product:" + this.product.id);
         
  // console.log("product: "+ this.product.price)
          const productQuantity = (!quantity || quantity < 1) ? 1 : parseInt(quantity)

           console.log("index:" + productQuantity);
          if (index === null) {
              var items = {
                  product: this.product,
                  quantity: productQuantity
              }
              //this.$store.commit('catalog/updateCart', items)
            
              this.$store.commit('updateCart', items)
          }else {
            if(!quantity){
              // If item is already into the cart then add++ quantity      

              this.$store.commit('increaseQuantity', index)
                
            }else{
              // When quantity updated manually
            }
          }        
        },
        removeCart(index){
          this.$store.commit('removeCart', index)     
        }, 
    //      getProduct() {

    // }
    },
    // mounted(){
    // this.getProduct();


    // },
    created(){
      var db = firebase.firestore();
      
      // Current Currency   
      db.collection("settings").doc('config').onSnapshot(doc =>{
        this.currency = doc.data().currency
      })


//https://us-central1-elatukku-23ef3.cloudfunctions.net/getProductdetail?product_id=
axios.get('https://europe-west1-elatukku-23ef3.cloudfunctions.net/getProductdetail?product_id='+this.$route.params.id)
.then ( res=> {
  let element=[]

//this.product=res.data

       element.name=res.data.name
       element.item_name=res.data.name
       element.product_id=res.data.product_id
       element.price=(Math.round(res.data.price * 100) / 100).toFixed(2);
   //    element.vat=res.data.vat
        element.vatpercent=res.data.vatpercent
        element.size= (Math.round(res.data.size * 100) / 100).toFixed(2); 
        element.measureunit=res.data.measureunit
       element.code=res.data.code
       element.iscampaign=false

      // element.issaleble=res.data.issaleable
       element.id=res.data.product_id

   //    element.vatpercent=res.data.vatpercent
       var asdx=res.data.images.find(img=>img.variant=="medium");
       if(asdx!=null)
       element.image=asdx.url;
       else
       element.image="";
       
       let amountc=1;
       let pckid="";
       var asd=res.data.packages.find(pck=>pck.isdefault==true);
       if(asd!=null)
       {
       amountc=asd.amount;
       pckid=asd.package_id;
       }
       else       
        amountc=1;

       element.package_price=(Math.round(amountc*element.price * 100) / 100).toFixed(2); 
      //  element.price1a=res.data.prices[0].amount
      //  element.price1p=res.data.prices[0].price
      //  element.price1Defaul=res.data.prices[0].ispricelistpricedefault
      //  element.price1a=res.data.prices[1].amount
      //  element.price1p=res.data.prices[1].price
      //  element.price1Defaul=res.data.prices[1].ispricelistpricedefault
      // element.imagex=res.data.images[1].url
     element.category_name=null
     element.packageamount=amountc,
     element.package_id=pckid

      this.product=element
  //    product.id=res.data.product_id
   
}).catch( error => { console.log(error); });




// async showdblist() {
//     this.dbs = await axiosGet(this.url)
//     // now this.dbs is correct
// }


//this.product=element;


      // // Product Details        
      // db.collection("items").doc(this.$route.params.id).onSnapshot(doc =>{
      //   this.product = doc.data()
      //   this.product.id = doc.id         
      // }) 
    }
  }
</script>

<style scoped> 
  .products_detail .v-card__title[data-v-67c1f075] {
      padding: 0px 0 0;
  }
  .flex_box .v-card{
    padding:20px; 
    width:100%;
  }
  .flex_item .headline{
    width:100%;
    margin:10px 0!important;
  }
  .flex_box .v-card__text {
    padding: 0px;
  }
  .flex_box .v-card__title {
    padding:10px 0 0;
  }  
 .quantity_border{
   border:3px solid #efeded;
 }
 .quantity{
    height: auto;
    width:0%; 
    display: grid;
    justify-items: center;
    align-items: center;
    text-align: center;
    margin-right: 5%;
  }
 .quantity .material-icons  {
    font-size: 22px;  
  }
 .quantity .add{
    cursor:pointer;
    border:1px solid #E0E0E0;
    border-right:none;
  }
  .quantity .remove{
    cursor:pointer;
    border:1px solid #E0E0E0;
    border-left:none;
  }
  .quantity .quantity_no{
    border:1px solid #E0E0E0;
    padding:0 3px;
  }
  /*--
 .v-responsive{
   height:300px!important;
 }
 @media (max-width:240px){
   .v-responsive{
      height:200px!important;
    }
 }
 --*/
  @media (max-width:599px){
    .v-text-field.v-text-field--solo .v-input__control {
      min-height: 38px!important;
      padding: 0;
      margin-bottom: 5px;
    }
    .flex_item .headline {
    margin:0 0 10px 0px!important;
}
  }
  @media (max-width:420px){
    .products_detail h4,.products_detail .my-3{
        font-size: 20px!important;
    } 
    .flex_box .v-card{
      padding-top:0!important;
      padding-bottom:0!important;  
    }   
  }
</style>



// WEBPACK FOOTER //
// src/components/shop/products/ProductDetails.vue